import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {PropTypes} from 'prop-types';

import * as Actions from "../../../../store/modules/scholars";
import * as func from "../../../../utils/functions";
import {objectToQueryString, pushUrl} from "../../../../utils/functions";
import {BASE_PATH, STATUS_NAME} from "../../../../wpconfig";

class ScholarSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url : 'wp-admin/admin.php?page=scholar&',
			action : 'admin/scholars',
			modalShow : "false",
			status : 'publish',
		}

		this.argsInputTextEvnet = this.argsInputTextEvnet.bind(this)
	}

	argsInputTextEvnet = (event) => {
		event.preventDefault();
		// event.stopPropagation();

		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setScholars({"param": param});

		if (event.key === "Enter") {
			this.search(event);
		}
		return false;
	}

	search = (event) => {
		event.preventDefault();

		func.getData(this.state.action, this.props.param).then((response) => {
			response.checkedRecords = []
			this.props.dataActions.setScholars(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
		return false;
	}

	linkDetail = (event) => {
		event.preventDefault()

		window.location.href = "admin.php?" + window.location.href.split("?")[1] + "&record_id=&tab_id=0";
	}

	onChange = (event) => {
		event.preventDefault()

		let state = this.state;
		state[event.target.name] = event.target.value;
		this.setState(state)
		this.forceUpdate()
	}

	deleteTrash = (event) => {
		event.preventDefault()

		if(confirm('정말로 삭제하시겠습니까?')) {
			func.getData('admin/scholar/delete_trash' , this.props.param).then((response) => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setScholars(response);
				});
			});
		}
	}

	statusAction = (event) => {
		event.preventDefault()

		if (this.props.checkedRecords <= 0) {
			alert('하나 이상 선택해주세요.')
			return
		}

		if(this.state.status === 'delete') {
			if(confirm('정말로 삭제하시겠습니까?')) {
				func.updateData('admin/scholar/delete_trash' , this.props.param).then((response) => {
					func.getData(this.state.action, this.props.param).then((response) => {
						response.checkedRecords = []
						this.props.dataActions.setScholars(response);
					});
				});
			}
		} else {
			let param = {
				ids : this.props.checkedRecords,
				status : this.state.status
			}
			func.updateData('admin/scholar/status' , param).then((response) => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setScholars(response);
				});
			});
		}
	}

	onOpenPopup = (event) => {
		event.preventDefault()

		let state = this.state;
		state['modalShow'] = 'true'
		this.setState(state)
		this.forceUpdate()
	}

	onClosePopup = (event) => {
		event.preventDefault()

		let state = this.state;
		state['modalShow'] = 'false'
		this.setState(state)
		this.forceUpdate()
	}

	render() {

		return (
			<>
				<div className="d-flex justify-content-center mb-3">
					<div className="form-inline">
						<input type="text" className="form-control form-control-lg top-search mr-1" id="ks" name="ks"
							   defaultValue={this.props.param.ks} onKeyUp={this.argsInputTextEvnet} />
						<button type="button" className="btn btn-primary btn-top-search" onClick={this.search}>Search</button>
					</div>
				</div>
				<div className="d-flex mb-1">
					<div className="d-flex mb-1">
						<div className="">
							<select className="form-control d-inline-block mr-1"
							        name="status" onChange={this.onChange}
							        style={{width : "100px", height: '32px', marginRight: "6px !important"}}
							        value={this.state.status}>
								{Object.keys(STATUS_NAME).map((item, index) => {
									return (<option key={index} value={item}>{STATUS_NAME[item]}</option>)
								})}
							</select>
							<a href="#" className="btn btn-outline-secondary btn-sm resource-update-status mr-2" onClick={this.statusAction}>
								{this.state.status === 'delete' ? '휴지통 모두 비우기' : '상태 변경'}</a>
							<a name="modalShow"
							   onClick={this.onOpenPopup}
							   className="btn btn-outline-secondary btn-sm resource-sendmail mr-1">연구자 합치기</a>
						</div>
					</div>
					<div className="ml-auto">
						<a href="#" onClick={this.linkDetail} className="btn btn-success btn-sm">추가</a>
					</div>
				</div>

				{this.state.modalShow === 'true' &&
				<div id="resource_sendmail_option" className="modal-mask modal-rm">
					<div className="modal-wrapper">
						<div className="modal-container modal-content">
							<div className="modal-header"><h1 className="modal-title">연구자 합치기</h1>
								<button type="button" className="close" onClick={this.onClosePopup}>
									<span aria-hidden="true" onClick={this.onClosePopup}>×</span></button>
							</div>
							<div className="modal-body">
								<div className="row">
									<div className="col-12">
										<h6 className="mb-2">[개발중] 메일유형</h6>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<div className="input-group mb-2">
											<div className="form-check form-check-inline mr-3">
												{/*<input className="form-check-input" type="radio" name="mail_type"*/}
												{/*       checked={this.state.mail_type === 'myself'} id="myself" value="myself"*/}
												{/*       onChange={this.onChecked}/>*/}
												<label htmlFor="myself" className="form-check-label">본인확인요청</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-sm btn-primary mr-1">합치기</button>
							</div>
						</div>
					</div>
				</div>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		param: state.scholars.param ? state.scholars.param : {},
		checkedRecords: state.scholars.checkedRecords ? state.scholars.checkedRecords : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ScholarSearch)

// JournalSearch.propTypes = {
//     args : PropTypes.object,
// }
